<template>
  <div class="careers-jobs">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="text-group">
        <h3 class="text-accent">{{ $t('careers-jobs-1') }}</h3>
        <h1>{{ $t('careers-jobs-2') }}</h1>
        <h2>{{ $t('careers-jobs-3') }}</h2>
      </div>
    </div>
    <div class="jobs-container">
      <header>
        <a class="link" @click="filter = ''">
          <span class="text-light">Всички обяви ({{ jobs.length }})</span>
        </a>
        <div class="select-wrapper">
          <p class="text-light">Филтрирай по дружество:</p>
          <select required v-model="filter">
            <option value selected disabled>Всички дружества от КЦМ</option>
            <option value="ХОЛДИНГ КЦМ 2000 АД">ХОЛДИНГ КЦМ 2000 АД</option>
            <option value="КЦМ АД">КЦМ АД</option>
            <option value="КЦМ Трейд ЕООД">КЦМ Трейд ЕООД</option>
            <option value="КЦМ Технолоджи ЕООД">КЦМ Технолоджи ЕООД</option>
            <option value="Комплексен индустриален сервиз ЕООД">Комплексен индустриален сервиз ЕООД</option>
            <option value="Металургремонт 21 EАД">Металургремонт 21 EАД</option>
            <option value="Стопански дейности КЦМ ЕООД">Стопански дейности КЦМ ЕООД</option>
            <option value="Стройсервиз ЕООД">Стройсервиз ЕООД</option>
            <option value="Индустриална зона КЦМ ЕООД">Индустриална зона КЦМ ЕООД</option>
            <option value="Лъки Инвест АД">Лъки Инвест АД</option>
            <option value="Върба-Батанци АД">Върба-Батанци АД</option>
            <option value="BLZ Metalikon Ltd">BLZ Metalikon Ltd</option>
            <option value="MCM BV">MCM BV</option>
          </select>
        </div>
      </header>
      <div class="jobs-rows">
        <router-link
          :to="`/careers?page=jobsPreview&id=${a._id}`"
          class="jobs-row"
          v-for="a in filteredJobs"
          :key="`ad-${a._id}`"
        >
          <p>{{ a.position }}</p>
          <p>{{ a.company }}</p>
        </router-link>
      </div>
    </div>
    <Apply />
  </div>
</template>

<script>
import Apply from './shared/Apply';
export default {
  components: {
    Apply
  },
  data() {
    return {
      filter: '',
      jobs: []
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    filteredJobs() {
      return this.jobs.filter(a => {
        if (!this.filter) {
          return true;
        }
        return a.company === this.filter;
      });
    }
  },
  watch: {
    '$i18n.locale'() {
      this.checkLang();
    }
  },
  methods: {
    getJobs() {
      let url = `${process.env.VUE_APP_BASE_URI}/jobs`;

      this.$http
        .get(url)
        .then(result => {
          this.jobs = result.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    checkLang() {
      if (this.$i18n.locale !== 'bg') {
        this.$snotify.warning(
          'The application jobs are available only in Bulgarian.'
        );
        this.$router.push('/careers');
      }
    }
  },
  mounted() {
    this.checkLang();
    this.getJobs();
  }
};
</script>

<style lang="scss" scoped>
.careers-jobs {
  position: relative;
  .row-1 {
    padding-left: $sidesPadding;
    padding-right: $sidesPadding;
  }
}
.jobs-container {
  padding-bottom: $sidesPadding;
  padding-right: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  padding-left: $sidesPadding + $chemicalLarge + ($sidesPadding / 2);
  header {
    @extend %flex-center;
    background-color: $mainColor;
    color: #fff;
    height: 44px;
    justify-content: space-between;
    margin: 20px 0 30px;
    padding: 30px 15px;
    @include transition(all 0.3s);
    .link {
      margin-bottom: -10px;
    } 
    .link::before {
      background-color: $accentColor;
    }
    .select-wrapper {
      align-items: center;
      display: flex;
      width: 50%;
      p {
        margin-right: 10px;
        white-space: nowrap;
      }
      select {
        border: none;
      }
    }
    p {
      font-weight: 500;
    }
  }
}
select,
select:invalid {
  color: #fff;
}
select option:not([disabled]) {
  color: #000;
}

.jobs-rows {
  .jobs-row {
    display: block;
    border-bottom: 1px solid #707070;
    cursor: pointer;
    padding: 15px;
    p {
      font-size: 14px;
    }
    & p:first-child {
      color: #2d80d5;
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      margin-bottom: 5px;
    }
    &:hover {
      background-color: rgba(178, 200, 210, 0.2);
    }
  }
}

@media screen and (max-width: 1600px) {
  .careers-jobs {
    .row-1 {
      padding-left: $sidesPadding1600;
      padding-right: $sidesPadding1600;
    }
    .jobs-container {
      padding-bottom: $sidesPadding1600;
      padding-right: $sidesPadding1600 + $chemicalLarge +
        ($sidesPadding1600 / 2);
      padding-left: $sidesPadding1600 + $chemicalLarge + ($sidesPadding1600 / 2);
    }
  }
}
@media screen and (max-width: 1440px) {
  .jobs-container {
    padding-right: $sidesPadding1600 + $chemicalLarge1440 +
      ($sidesPadding1600 / 2);
    padding-left: $sidesPadding1600 + $chemicalLarge1440 +
      ($sidesPadding1600 / 2);
    header {
      p {
        font-size: 13px;
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .careers-jobs {
    .row-1 {
      padding-left: $sidesPadding1280;
      padding-right: $sidesPadding1280;
    }
    .jobs-container {
      padding-bottom: $sidesPadding1280;
      padding-right: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
      padding-left: $sidesPadding1280 + $chemicalLarge1440 +
        ($sidesPadding1280 / 2);
    }
  }
}
@media screen and (max-width: 1000px) {
  .careers-jobs {
    .row-1 {
      padding: $sidesPadding1280;
    }
    .jobs-container {
      padding: $sidesPadding1280;
      padding-right: $sidesPadding1280;
      padding-left: $sidesPadding1280;
      header {
        p {
          font-size: 12px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .careers-jobs {
    .row-1 {
      padding: $sidesPadding600;
    }
    .jobs-container {
      padding: $sidesPadding600;
      padding-top: 0;
      header {
        margin: 10px 0;
        padding: 0 10px;
      }
    }
  }
}
</style>
